import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { EmptyObject } from './common/utils';
import { TLocation } from './core/entities';
import { SitePathMixin } from './core/site.path.utils';
import { SessionCache } from './session.cache';
import { SessionService } from './session.service';
import { Carousel2Widget, CarouselItemDirective } from './user/carousel2';
import { LocationCard } from './user/location.card';

@Component({
  selector: 'app-random-location-list',

  standalone: true,
  imports: [
    CommonModule, 
    LocationCard, 
    RouterLink, 
    //CarouselWidget,
    Carousel2Widget,
    CarouselItemDirective],
  templateUrl: './random.location.list.html',
})
export class RandomLocationListPage extends SitePathMixin(EmptyObject) {
  susbcription: Subscription;

  list: TLocation[] = [];
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private router: Router,
    private session: SessionService,
    private cache: SessionCache
  ) {
    super();
  }
  ngOnInit() {
    this.refresh();
  }

  refresh() {
    this.cache.loadAllLocation((list) => {
      this.list = [];
      let l = list.slice();
      while (l.length) {
        let index = Math.floor(Math.random() * l.length);
        this.list.push(l[index]);
        l.splice(index, 1);
      }
    });
  }
}
